<body>
  <section class="background">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-5">
          <div class="logo mt-3">
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(dec-28)/assets/image/logo.png" alt="logo"
            />
          </div>
          <h1>
            <span class="new">NEW</span>
            <h1 class="ml7">
              <span class="text-wrapper">
                <span class="revolutionized letters">REVOLUTIONIZED</span>
              </span>
            </h1>
            <span class="internet ml13">INTERNET MARKETING SOLUTIONS</span>
          </h1>
          <div class="d-none d-md-block">
            <div class="bfn">
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                class="btn text-uppercase"
                target="_blank"
                rel="noopener"
                >become a founder now</a
              >
            </div>
            <div class="social-image">
              <a
                href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/fb.png"
                  title="Facebook"
                  class="icon"
                  alt="facebook"
                /> </a
              >&nbsp;
              <a
                href="https://twitter.com/ONPASSIVE"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/twitter.png"
                  title="Twitter"
                  class="icon"
                  alt="Twitter"
                /> </a
              >&nbsp;
              <a
                href="https://www.instagram.com/ONPASSIVE/"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/insta.png"
                  title="Instagram"
                  class="icon"
                  alt="Instagram"
                /> </a
              >&nbsp;
              <a
                href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/youtube.png"
                  title="Youtube"
                  class="icon"
                  alt="YouTube"
                /> </a
              >&nbsp;
              <a
                href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/in.png"
                  title="LinkedIn"
                  class="icon"
                  alt="LinkedIn"
                /> </a
              >&nbsp;
              <a
                href="http://onpassive.com/blog"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/blog.png"
                  title="ONPASSIVE Blog"
                  class="icon1"
                  alt="Blog"
                />
              </a>
              &nbsp;
            </div>
          </div>
        </div>
        <div class="col-lg-7 index mt-3">
          <h1 class="ml11 text-right">
            <span class="text-wrapper">
              <span class="line line1"></span>
              <span class="letters">LAUNCHING SOON!</span>
            </span>
          </h1>
          <!--  <h1 class="launch">LAUNCHING SOON!</h1> -->
          <div class="video-box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <p class="para">
                You always cannot buy a rare opportunity. But never look away
                when you see one. ONPASSIVE gives you access to a bundle of
                business opportunities to satisfy your appetite for success.
              </p>
            </div>
          </div>
          <div class="d-block d-md-none">
            <div class="bfn">
             
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                class="btn text-uppercase mt-0 mb-2"
                target="_blank"
                rel="noopener"
                >become a founder now</a
              >
            </div>
            <div class="social-image mb-3">
              <a href="https://www.facebook.com/ONPASSIVE/onpassiveworld">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/fb.png"
                  title="Facebook"
                  class="icon"
                  alt="Facebook"
                />
              </a>
              <a href="https://twitter.com/ONPASSIVE">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/twitter.png"
                  title="Twitter"
                  class="icon"
                  alt="Twitter"
                />
              </a>
              <a href="https://www.instagram.com/ONPASSIVE/">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/insta.png"
                  title="Instagram"
                  class="icon"
                  alt="Instagram"
                />
              </a>
              <a
                href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/youtube.png"
                  title="Youtube"
                  class="icon"
                  alt="YouTube"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/in.png"
                  title="LinkedIn"
                  class="icon"
                  alt="LinkedIn"
                />
              </a>
              <a href="http://onpassive.com/blog">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-28)/assets/image/icon/blog.png"
                  title="ONPASSIVE Blog"
                  class="icon1"
                  alt="blog"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</body>
